{
  "LEGEND_DESCRIPTION": "Legende Betriebszustand"
}
